import { render, staticRenderFns } from "./Partnership.vue?vue&type=template&id=9f84f954&scoped=true&"
import script from "./Partnership.vue?vue&type=script&lang=js&"
export * from "./Partnership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f84f954",
  null
  
)

export default component.exports